import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from '../home/Home';
import Community from '../community/Community';
import CommunityCreate from '../community/CommunityCreate';
import Profile from '../profile/Profile';
import ProfileUpdate from '../profile/ProfileUpdate';
import ProfileRead from '../profile/ProfileRead';
import MyCommunities from '../my-communities/MyCommunities';
import MyEvents from '../my-events/MyEvents';
import { Login } from '../auth/Login';
import { Register } from '../auth/Register';
import { Logout } from '../auth/Logout';
import { Token } from '../auth/Token';
import CommunityPostUpdate from '../community/CommunityPostUpdate';
import { CommunityProvider } from '../community/CommunityContext';
import Event from '../event/Event';
import { EventProvider } from '../event/EventContext';
import EventCreate from '../event/EventCreate';
import EventUpdate from '../event/EventUpdate';
import Explore from '../explore/Explore';

const URLRoutes = () => {
  const { getToken } = Token();
  if (getToken()){
    console.log("logged in")
    return(
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home/>}/>
          <Route path="/explore/*" element={<Explore/>} />
          <Route path="/my-communities" element={<MyCommunities/>}/>
          <Route path="/my-events" element={<MyEvents/>}/>
          <Route path="/community/create" element={<CommunityCreate/>} />
          <Route path="/community/:id/discussion/:postId/update" element={<CommunityPostUpdate />} />
          <Route path="/community/:id/*" element={ 
            <CommunityProvider>
              <Community/>
            </CommunityProvider>
          } />
          <Route path='/logout' element={<Logout />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/profile/update' element={<ProfileUpdate />} />
          <Route path='/profile/:email' element={<ProfileRead />} />
          <Route path="/event/:id" element={
            <EventProvider>
              <Event />
            </EventProvider>
          } />
          <Route path="/event/:id/update" element={
            <EventProvider>
              <EventUpdate />
            </EventProvider>
          } />
          <Route path='/event/create' element={<EventCreate />} />
          <Route path='*' element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    console.log("not logged in")
      return(
      <BrowserRouter>
        <Routes>
          <Route path='/register' element={<Register />} />
          <Route path='/login' element={<Login />} />
          <Route path='*' element={<Navigate to="/login" />}/>
        </Routes>
      </BrowserRouter>
    )
  }
}

export default URLRoutes
